//This file is automatically rebuilt by the Cesium build process.
export default "const float czm_piOverFour = 0.7853981633974483;\n\
";
